import * as z from "zod";

export const disconnectCreditsYardIntegration = {
  name: "disconnectCreditsYardIntegration" as const,
  input: z.object({}),
  output: z.object({}),
};
